import { m } from '@sohanscript/i18n';
import { z } from 'zod';

type DevMenuItem = {
	id: string;
	label: () => string;
	description: () => string;
	key: string;
	type: z.ZodTypeAny;
};

export const devMenuItems = [
	{
		id: 'query-logger',
		label: m.dev_item_query_logger,
		description: m.dev_item_query_logger_desc,
		key: 'queryLogger' as const,
		type: z.boolean(),
	},
	{
		id: 'responsive-indicator',
		label: m.dev_item_responsive_indicator,
		description: m.dev_item_responsive_indicator_desc,
		key: 'responsiveIndicator' as const,
		type: z.boolean(),
	},
	{
		id: 'disable-posthog',
		label: m.dev_item_disable_posthog,
		description: m.dev_item_disable_posthog_desc,
		key: 'disablePosthog' as const,
		type: z.boolean(),
	},
	{
		id: 'disable-batching',
		label: m.dev_item_disable_batching,
		description: m.dev_item_disable_batching_desc,
		key: 'disableBatching' as const,
		type: z.boolean(),
	},
] satisfies DevMenuItem[];

export type DevMenuKey = (typeof devMenuItems)[number]['key'];
export type DevMenuSettings = Record<DevMenuKey, boolean>;

export const devMenuSchema = z.object(
	Object.fromEntries(devMenuItems.map((i) => [i.key, i.type])),
) as z.ZodObject<Record<DevMenuKey, z.ZodBoolean>>;

const COOKIE_PREFIX = 'dm-';

export const devCookieKey = (key: DevMenuKey) =>
	`${COOKIE_PREFIX}${btoa(key).replace(/=/g, '')}`;

export const getDevSettingSync = (key: DevMenuKey): boolean => {
	if (typeof document === 'undefined') return false;
	const match = document.cookie
		.split(';')
		.find((c) => c.trim().startsWith(`${devCookieKey(key)}=`));
	return match?.split('=')[1] === 'true';
};

export const setDevSetting = (key: DevMenuKey, value: boolean) => {
	if (typeof document === 'undefined') return;
	document.cookie = `${devCookieKey(key)}=${value};path=/;max-age=${30 * 24 * 60 * 60};SameSite=Lax`;
};

export const getDevSettings = (): DevMenuSettings => {
	const settings = {} as DevMenuSettings;
	for (const item of devMenuItems) {
		settings[item.key] = false;
	}
	return settings;
};
